<script setup lang="ts">
import { PropType } from 'vue';
import { AppCoreEnums } from '../../shared/enums';
import AppDynamicFilterItemDate from './app-dynamic-filter-item-date.vue';
import { dropdownPreset } from '../../../presets/customizations/dropdown';
import AppDynamicFilterMultiSelect from './app-dynamic-filter-multi-select.vue';
import { IDateRange, IDynamicFilterValueOptions } from '../../../stores/core/models';

const filterValue = defineModel<string | string[] | IDateRange | undefined>('filterValue', { required: true });

const props = defineProps({
  filterValueOptions: {
    type: Object as PropType<IDynamicFilterValueOptions>,
  },
});
</script>

<template>
  <!-- Select -->
  <Select
    v-if="props.filterValueOptions?.type === AppCoreEnums.FilterItemType.Select"
    v-model="filterValue"
    :options="props.filterValueOptions.options"
    optionLabel="label"
    option-value="key"
    :placeholder="$t('core.selectFilterPlaceholder')"
    class="w-full min-w-full"
    :ptOptions="{ mergeSections: true, mergeProps: true }"
    :pt="dropdownPreset"
  />

  <!-- Multi Select -->
  <app-dynamic-filter-multi-select
    class="mt-2"
    v-model:value="(filterValue as string[])"
    :items="props.filterValueOptions?.options"
    v-if="props.filterValueOptions?.type === AppCoreEnums.FilterItemType.MultiSelect"
  />

  <!-- Range Date Time -->
  <app-dynamic-filter-item-date
    style="padding-left: 15px"
    :show-time="props.filterValueOptions?.type === AppCoreEnums.FilterItemType.DateWithTime"
    v-model="(filterValue as IDateRange)"
    v-if="
      props.filterValueOptions?.type === AppCoreEnums.FilterItemType.Date ||
      props.filterValueOptions?.type === AppCoreEnums.FilterItemType.DateWithTime
    "
  />

  <!-- Text Input -->
  <InputText
    class="w-full mt-2"
    v-if="props.filterValueOptions?.type === AppCoreEnums.FilterItemType.Text"
    v-model="filterValue as string"
  />
</template>
